module.exports = __webpack_public_path__ + "img/word.4db32bcd.svg";